// Unpublished Work © 2026 Deere & Company.

import {groupBy, orderBy} from 'lodash';
import {LIFETIME, LIFETIME_REPORT_START_DATE} from 'Src/ui-core/components/graph/constants/graph-filters';
import {NINETY_DAYS, THIRTY_DAYS} from 'Src/ui-core/constants/time-constants';

function getDateRangePresets(translations, moment) {
    return [
        {
            id: 'today',
            title: translations.days_Today,
            getSelectedDates: () => [moment().startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        {
            id: 'last30days',
            title: translations.LAST_30_DAYS,
            getSelectedDates: () => [moment().startOf('day').subtract(THIRTY_DAYS, 'days').toDate(), moment().endOf('day').toDate()]
        },
        {
            id: 'last90days',
            title: translations.LAST_90_DAYS,
            getSelectedDates: () => [moment().startOf('day').subtract(NINETY_DAYS, 'days').toDate(), moment().endOf('day').toDate()]
        },
        {
            id: 'thisMonth',
            title: translations.THIS_MONTH,
            getSelectedDates: () => [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
        },
        {
            id: 'thisYear',
            title: translations.THIS_YEAR,
            getSelectedDates: () => [moment().startOf('year').toDate(), moment().endOf('day').toDate()]
        },
        {
            id: LIFETIME,
            title: translations.LIFETIME,
            getSelectedDates: () => [LIFETIME_REPORT_START_DATE, moment().endOf('day').toDate()]
        }
    ];
}

function getGroupedEquipmentByModel(equipment) {
    const equipmentByModel = groupBy(equipment, 'modelId');

    const groupedEquipment = orderBy(Object.keys(equipmentByModel).map((modelId) => ({
        id: modelId,
        title: equipmentByModel[modelId][0].modelName,
        items: equipmentByModel[modelId].map((equipmentItem) => ({
            id: equipmentItem.equipmentId,
            title: equipmentItem.equipmentName
        }))
    })), 'title');

    return {
        groupedEquipment
    };
}

export {
    getGroupedEquipmentByModel,
    getDateRangePresets
};
